export const hasAuthenticatedUserData = (userData) =>
  Boolean(userData && typeof userData === "object" && Object.keys(userData).length);

export const getAuthToken = (userData) =>
  userData?.token || localStorage.getItem("token") || null;

export const isOrganisationGroupUser = (userData) =>
  Boolean(userData?.organisationGroupId?._id);

export const getAuthenticatedHomeRoute = (userData) =>
  isOrganisationGroupUser(userData)
    ? "/organisations/dashboard"
    : "/Dashboard";

export const isAllowedAuthenticatedRoute = (pathname, userData) => {
  if (!pathname) return false;
  if (!hasAuthenticatedUserData(userData)) return false;

  const isOrganisationRoute = pathname.startsWith("/organisations");
  return isOrganisationRoute === isOrganisationGroupUser(userData);
};
